export default {
    methods: {
        fullname(user) {
            if (user) {
                const n = ['firstname', 'middlename', 'lastname'];
                let names = Object.keys(user)
                    .map((key) => {
                        if (n.indexOf(key) !== -1)
                            return user[key];
                    });
                    names.filter(function (item,pos){
                        return names.indexOf(item) === pos;
                    });
                return names.join(' ');
            } else {
                return "None";
            }
        },
        formatFn(value) {
            return new Intl.NumberFormat().format(value)
        },
        postScroll(id) {
            const element = document.getElementById(id);
            element.scrollIntoView({behavior: "smooth", block: "end"});
        },
        handleLaravelErrors(errors) {
            Object.keys(errors).forEach((field) => {
                this.$validator.errors.add({
                    field: field,
                    msg: errors[field][0], // Assuming there's only one error per field
                });
            });
        },
        getStatusClass(status){
            return {
                "badge-success": status === 'approved',
                'badge-danger': status === 'rejected',
                'badge-secondary': status === 'pending',
            }
        },
        getPaidClass(status){
            return status ? "badge-success" : "badge-warning";
        },
    }
}